<!--
	RegisterPage.svelte
-->

<script>
	import { onMount } from 'svelte';
    import { location } from 'svelte-spa-router';			// new 11/2

    // TCARE components
    // import PageBanner from '../../components/common/PageBanner.svelte';

    onMount(() => {
    })

</script>

<style>

    .register-page {
        width: 100%;
        height: 100vh;
        background: linear-gradient(#391A52, #611C73);
    }

    .register-page img {
        position: fixed;
        width: 554px;
        height: 325px;
        top: 117px;        
        left: 12%;
    }

</style>

<div class="register-page">
    <img src='/img/Family_Group_Photo.png' alt='Family Group' draggable="false">
</div>

